<template>
  <div class="container-fluid p-0">
    <PageTitle :title="pageTitle" :titleSave="$t('label.salvar')" :isAdd="false" v-on:onSave="save()" v-on:onCancel="cancel()" :nameEdit="nameEdit" :withOutExcluir="true"/>

    <!-- tabela -->
    <div class="row">
      <div class="col-12 d-flex">
          <div class="card flex-fill ">
            <div class="card-body box-dashboard p-3">
              <div class="align-self-center">
                <div class="row">
                  <div class="col-md-6">
                    <div class="mb-3 ">
                      <label for="estado" class="form-label">{{ $t('label.estado') }}</label>
                      <input class="form-control" type="text" v-model="form.scientific_name" disabled="disabled">
                      <div class="invalid-feedback">
                        {{ $t('message.requiredField') }}
                       </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="mb-3 ">
                      <label for="email_group" class="form-label">{{ $t('label.grupoDeEmails') }}</label>
                      <v-select multiple :appendToBody="true" :filterable="false" @search="getEmailGroup" :options="groupList" v-model="relSpeciesEmailGroupSelected" label="name" index="email_group_id"
                          :reduce="r => r.email_group_id" :clearable="false" class="wf-select vue-select">
                          <template v-slot:selected-option="option">
                            {{ `${option.name}` }}
                          </template>
                          <template v-slot:option="option">
                            {{ `${option.name}` }}
                          </template>
                          <template v-slot:no-options="{ search, searching }">
                            <template v-if="searching">
                              {{`${ $t('message.noResultsFor') } `}}<em>{{ search }}</em>.
                            </template>
                          </template>
                        </v-select>
                      <div class="invalid-feedback">
                        {{ $t('message.requiredField') }}
                       </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import PageTitle from '@/components/shared/PageTitle'
export default {
  name: 'EspecieEmailForm',
  components: {
    PageTitle
  },
  data: function () {
    return {
      pageTitle: `${this.$t('label.especie')} > Adicionar`,
      nameEdit: '',
      groupList: [],
      relSpeciesEmailGroupSelected: [],
      action: this.$actionNew,
      form: {}
    }
  },
  methods: {
    getById: function (id) {
      this.$store.dispatch('showPreload')
      axios.get(`/Specie/config-email/${id}`)
        .then(response => {
          this.form = response.data
          this.nameEdit = ` ${this.form.scientific_name}`
          this.getRelSpeciesEmailGroupSelected()
        })
    },
    getRelSpeciesEmailGroupSelected: function () {
      this.relSpeciesEmailGroupSelected = []
      this.form.relSpeciesEmailGroup.forEach(e => {
        if (!this.relSpeciesEmailGroupSelected.includes(e.email_group_id)) {
          this.relSpeciesEmailGroupSelected.push(Number(e.email_group_id))
        }
      })
      this.getEmailGroup()
    },
    getEmailGroup: function (search, loading) {
      const params = {
        Page: 1,
        PageSize: 9999
      }
      if (search && search.length > 2) {
        params.name = search
        params.email_group_id_array = this.relSpeciesEmailGroupSelected.join(',')
        loading(true)
        axios.get('/SysEmailGroup/getallcombo', { params })
          .then(response => {
            this.groupList = response.data.items
            loading(false)
          })
      } else if (!search) {
        params.email_group_id_array = this.relSpeciesEmailGroupSelected.join(',')
        axios.get('/SysEmailGroup/getallcombo', { params })
          .then(response => {
            this.groupList = response.data.items
          })
      }
    },
    save: function () {
      this.form.relSpeciesEmailGroup = []
      this.relSpeciesEmailGroupSelected.forEach(el => {
        this.form.relSpeciesEmailGroup.push({ email_group_id: el, species_id: this.form.species_id })
      })
      axios.put('/Specie/config-email', this.form)
        .then(() => {
          this.$toasted.global.saved()
          this.cancel()
        })
    },
    cancel: function () {
      this.$router.replace('/admin/especies-email')
    }
  },
  created: function () {
    this.getEmailGroup()
    this.action =
      this.$route.params.id !== this.$actionNew
        ? this.$actionEdit
        : this.$actionNew

    if (this.action === this.$actionEdit) {
      this.pageTitle = `${this.$t('label.especie')} > Alterar`
      this.getById(this.$route.params.id)
    }
  }
}
</script>
